export const ProvincesQueryKeys = {
  GET_ALL_DEVISIONS: "provinces-get-all-devisions",
} as const;
